import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-crear-operacion',
  templateUrl: './crear-operacion.component.html',
  styleUrls: ['./crear-operacion.component.scss']
})
export class CrearOperacionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
